module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e36295da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/waterMark.vue
// module id = 964
// module chunks = 170